import { useCallback } from "react";
import useRemoveItem from "@vercel/commerce/wishlist/use-remove-item";
import useWishlist from "./use-wishlist";
import isLoggedIn from "../utils/tokens/is-logged-in";
import ensureIToken from "../utils/tokens/ensure-itoken";
import normalizeWishlist from "../utils/normalizations/normalize-wishlist";
export default useRemoveItem;
export const handler = {
    fetchOptions: {
        url: "wishlists",
        query: "removeWishedItem"
    },
    async fetcher ({ input , options , fetch  }) {
        //Uncomment the following line to debug
        /*    console.info(
      'useRemoveItem (wishlist) fetcher called. Configuration: ',
      'input: ',
      input,
      'options: ',
      options
    ) */ const { itemId , wishlistToken  } = input;
        if (!isLoggedIn() && !wishlistToken) {
            return null;
        }
        let token = ensureIToken();
        if (!itemId) {
            return null;
        }
        const { data: spreeWishlistSuccessResponse  } = await fetch({
            variables: {
                methodPath: "wishlists.removeWishedItem",
                arguments: [
                    token,
                    wishlistToken,
                    itemId
                ]
            }
        });
        if (spreeWishlistSuccessResponse) {
            const normalizedWishlist = normalizeWishlist(spreeWishlistSuccessResponse, spreeWishlistSuccessResponse.data);
            return normalizedWishlist;
        } else {
            return null;
        }
    },
    useHook: ({ fetch  })=>{
        const useWrappedHook = ()=>{
            const wishlist = useWishlist();
            return useCallback(async (input)=>{
                if (!wishlist.data) {
                    return null;
                }
                const data = await fetch({
                    input: {
                        itemId: `${input.id}`,
                        wishlistToken: wishlist.data.token
                    }
                });
                await wishlist.mutate(data, false);
                return data;
            }, [
                wishlist
            ]);
        };
        return useWrappedHook;
    }
};
